import { render, staticRenderFns } from "./InsuranceTariffCard.vue?vue&type=template&id=3686e95f&scoped=true"
import script from "./InsuranceTariffCard.vue?vue&type=script&lang=js"
export * from "./InsuranceTariffCard.vue?vue&type=script&lang=js"
import style0 from "./InsuranceTariffCard.vue?vue&type=style&index=0&id=3686e95f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3686e95f",
  null
  
)

export default component.exports